/**
 * Represents the types of background operations available.
 * Matches the Crown.X.Api.LongRunningOperations.Models.BackgroundOperationType enum.
 */
export enum BackgroundOperationType {
	/** Optimizes the route plan for efficiency. */
	EsriOptimizeRoute = 0,

	/** Calculates ETAs for a route plan. */
	EsriCalculateEtas = 1,

	/** Calculates ETAs for all route plans. */
	EsriCalculateAllEtas = 2
}